<template>
  <div class="sm:col-span-6">
    <div class="mt-1 pill__SearchInput InputGroupFocus !w-full mb-4">
      <input
        class="form-control !py-1 "
        type="text"
        :placeholder="$t('Search by Keywords')"
        v-model="keywords"
      />
      <aw-icon 
        icon="search" 
        v-show="!showCloseIcon"
      />
      <button 
        v-show="showCloseIcon"
        @click.stop.prevent="eraseSearch()"
        class="SearchInput__CloseIcon"
      >
        <aw-icon icon="close"/>
      </button>
    </div>
    <div class="PhotobankFilesWrapper__Images flex flex-col gap-2 relative h-auto">
      <div 
        v-if="results && results.length > 0"
        class="flex flex-col"
      >
        <div class="grid grid-cols-3 sm:grid-cols-6 gap-2">
          <photobank-file-preview 
            v-for="(item, i) in results"
            :key="i"
            :item="item"
          />
        </div>
        <div class="flex justify-end gap-4 mt-1">
          <button
            class="text-sm"
            :class="{'text-gray-200 pointer-events-none': previousNotAvailable}"
            @click.stop.prevent="showPrevious()"
          >
            <aw-icon
              icon="chevron-left"
              class="w-5 h-5 mr-1"
            />
            {{ $t('Previous') }}
          </button>
          <button
            class="text-sm"
            :class="{'text-gray-200 pointer-events-none': nextNotAvailable}"
            @click.stop.prevent="showNext()"
          >
            {{ $t('Next') }}
            <aw-icon
              icon="chevron-right"
              class="w-5 h-5 ml-1"
            />
          </button>
        </div>
      </div>
      <div 
        v-if="loading"
        class="PhotobankFilesWrapper__Loading absolute left-0 w-full h-full pt-5 flex items-center justify-center pointer-events-none select-none"
      >
        <aw-icon 
          icon="loader" 
          class="h-24 w-24 text-bc-blue"
        />
      </div>
      <div 
        v-if="!loading && !results"
        class="w-full h-full pt-5 flex items-center justify-center pointer-events-none select-none"
      >
        <span 
          class="text-gray-400"
        >
          {{ $t('Please fill name or keywords for getting suggested images.') }}
        </span>
      </div>
      <div 
        v-else-if="!loading && results.length === 0"
        class="w-full h-full pt-5 flex items-center justify-center pointer-events-none select-none"
      >
        <span 
          class="text-gray-400"
        >
          {{ $t('Please try different keywords.') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'
import { PhotobankApi } from '../../test-api/index.ts'
import handleApiError from '../../utils/handleApiError'

const photobankApi = new PhotobankApi({}, '/api/v2')
let cancelationToken
const CancelToken = axios.CancelToken;

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      keywords: null,
      limit: 6,
      offset: 0,
      loading: false,
      results: null,
      resultsTotalCount: null
    }
  },
  computed: {
    previousNotAvailable() {
      return this.offset < this.limit
    },
    nextNotAvailable() {
      return this.resultsTotalCount && this.offset > this.resultsTotalCount - this.limit
    },
    query() {
      return this.keywords ? this.keywords : this.$formValues['frm-editForm-editForm-name']
    },
    showCloseIcon() {
      return this.keywords && this.keywords.length
    }
  },
  methods: {
    showPrevious() {
      this.offset = this.offset - this.limit
      this.loadImages()
    },
    showNext() {
      this.offset = this.offset + this.limit
      this.loadImages()
    },
    eraseSearch() {
      this.keywords = null
    },
    async loadImages () {
      if (!this.query || this.query?.length < 3 || !this.visible) {
        return
      }

      this.loading = true

      if (cancelationToken !== undefined) {
        cancelationToken.cancel();
        cancelationToken = undefined
      }

      cancelationToken = CancelToken.source()
      const photobankImagesResponse = await handleApiError(() => photobankApi.photobankImages('unsplash', this.query, this.limit, this.offset, {
        cancelToken: cancelationToken.token
      }))

      this.results = photobankImagesResponse.data.results
      this.resultsTotalCount = photobankImagesResponse.data.totalCount
      this.loading = false
    },
    checkKeywords: debounce(function() {
      this.offset = 0
      this.loadImages()
    }, 300)
  },
  watch: {
    visible(newVal) {
      if (newVal && !this.keywords && !this.results) {
        this.checkKeywords()
      }
    },
    query() {
      this.checkKeywords()
    },
  },
}
</script>

<style lang="scss" scoped>
.PhotobankFilesWrapper__Images {
  min-height: 7rem;
}

.PhotobankFilesWrapper__Loading {
  background-color: rgba($color: #fff, $alpha: 0.7);
}
</style>
